import { Box,Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const DonorDashboardTable = () => {
  const donors = useSelector((state) => state.donor?.donors || []);
  const noOfDonors = donors.length;
  // Count salutations
  const counts = donors.reduce((acc, d) => {
    const key = d.salutation || "Unknown";
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const rows = Object.keys(counts);

  const total = rows.reduce((sum, r) => sum + (counts[r] || 0), 0);
  const difference = Math.abs((counts["Mr"] || 0) - (counts["Mrs"] || 0));

  return (
    <>
    <Box>
      
      <Typography variant="h6" sx={{ mb: 3 ,mt:5 ,fontWeight: "600"}}>No.of Donors:{noOfDonors}
        </Typography>
        <Typography variant="subtitle1" sx={{mb:1,fontWeight: "400" }}>Donor Salutation Summary
        </Typography>
        </Box>
      <table
        style={{
          width: "100%",
          minWidth: "260px",
          borderCollapse: "collapse",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr style={{ background: "#f0f0f0" }}>
            <th style={{ border: "1px solid #ddd", padding: "6px", fontWeight: "bold" }}>
              Salutation
            </th>
            <th style={{ border: "1px solid #ddd", padding: "6px", fontWeight: "bold" }}>
              Count
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r}>
              <td style={{ border: "1px solid #ddd", padding: "6px" }}>{r}</td>
              <td style={{ border: "1px solid #ddd", padding: "6px" }}>{counts[r] || 0}</td>
            </tr>
          ))}

          {/* Total row */}
          <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
            <td style={{ border: "1px solid #ddd", padding: "6px" }}>Total</td>
            <td style={{ border: "1px solid #ddd", padding: "6px" }}>{total}</td>
          </tr>

          {/* Difference row */}
          <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
            <td style={{ border: "1px solid #ddd", padding: "6px" }}>Difference</td>
            <td style={{ border: "1px solid #ddd", padding: "6px" }}>{difference}</td>
          </tr>
        </tbody>
      </table>
   </>
  );
};

export default DonorDashboardTable;